
const NoData = () => <div className={'h-100 d-flex justify-content-center align-items-center'}>

  <div className={"opacity-50"}> اطلاعاتی جهت نمایش وجود ندارد</div>

</div>

export default NoData;
